/**
 * RPS Classic (추억의 짱껜뽀) Official Landing Page Script
 * - Natural, Authentic Multilingual Dictionary (ko, en, ja)
 * - Automatic In-Phone Screenshot Carousel (Smooth Slider with Dots)
 */

const I18N_DICT = {
    ko: {
        brand_title: '추억의 짱껜뽀',
        logo_img: 'assets/ko_title_n.png',
        
        btn_google_play: 'GOOGLE PLAY',
        btn_app_store: 'APP STORE',
        
        hero_badge: '🕹️ 100원의 행복, 추억의 문방구 게임기',
        hero_tagline: '"짱~ 깸~ 뽀!"<br class="mobile-break">문방구 앞 그 게임기 그대로',
        hero_desc: '동전 넣고 가위바위보! 문방구 앞 그 손맛 그대로 즐겨보세요.',
        
        tag_1: '🪙 원작 손맛 그대로',
        tag_2: '🎰 20배 대박 메달',
        tag_3: '🎮 원터치 쉬운 조작',

        footer_rights: '© PROHIRO.COM All rights reserved.',
        footer_privacy: '개인정보처리방침'
    },
    en: {
        brand_title: 'RPS Classic',
        logo_img: 'assets/en_title_n.png',
        
        btn_google_play: 'GOOGLE PLAY',
        btn_app_store: 'APP STORE',
        
        hero_badge: '🕹️ Nostalgic 90s Street Arcade Machine',
        hero_tagline: '"Rock! Paper! Scissors!"<br class="mobile-break">The Classic Street Game',
        hero_desc: 'Drop a coin, play RPS, and enjoy authentic 90s arcade nostalgia!',
        
        tag_1: '🪙 100% Faithful Retro',
        tag_2: '🎰 20x Jackpot Wheel',
        tag_3: '🎮 Simple 1-Tap Fun',

        footer_rights: '© PROHIRO.COM All rights reserved.',
        footer_privacy: 'Privacy Policy'
    },
    ja: {
        brand_title: 'じゃんけん Classic',
        logo_img: 'assets/ja_title_n.png',
        
        btn_google_play: 'GOOGLE PLAY',
        btn_app_store: 'APP STORE',
        
        hero_badge: '🕹️ 駄菓子屋のあの懐かしいメダルゲーム',
        hero_tagline: '「じゃん・けん・ぽん！」<br class="mobile-break">あの駄菓子屋のゲームそのまま',
        hero_desc: 'コインを入れてじゃんけん！あの頃の懐かしい手応えをそのままに。',
        
        tag_1: '🪙 当時の操作感を再現',
        tag_2: '🎰 最大20배大当たり',
        tag_3: '🎮 ワンタップ爽快プレイ',

        footer_rights: '© PROHIRO.COM All rights reserved.',
        footer_privacy: 'プライバシーポリシー'
    }
};

class RpsI18n {
    constructor() {
        this.supportedLangs = ['ko', 'en', 'ja'];
        this.currentLang = this.detectLanguage();
    }

    detectLanguage() {
        const saved = localStorage.getItem('rps_lang');
        if (saved && this.supportedLangs.includes(saved)) {
            return saved;
        }

        const browserLangs = navigator.languages || [navigator.language || navigator.userLanguage || 'ko'];
        for (const bl of browserLangs) {
            const code = bl.toLowerCase().slice(0, 2);
            if (this.supportedLangs.includes(code)) {
                return code;
            }
        }
        return 'ko';
    }

    setLanguage(lang) {
        if (!this.supportedLangs.includes(lang)) return;
        this.currentLang = lang;
        localStorage.setItem('rps_lang', lang);
        document.documentElement.lang = lang;
        this.applyToDOM();

        document.querySelectorAll('.rps-lang-select').forEach(select => {
            select.value = lang;
        });
    }

    t(key) {
        const dict = I18N_DICT[this.currentLang] || I18N_DICT['ko'];
        return dict[key] !== undefined ? dict[key] : (I18N_DICT['ko'][key] || key);
    }

    applyToDOM() {
        document.querySelectorAll('[data-i18n]').forEach(el => {
            const key = el.getAttribute('data-i18n');
            const val = this.t(key);
            if (val) el.textContent = val;
        });

        document.querySelectorAll('[data-i18n-html]').forEach(el => {
            const key = el.getAttribute('data-i18n-html');
            const val = this.t(key);
            if (val) el.innerHTML = val;
        });

        document.querySelectorAll('[data-i18n-src]').forEach(el => {
            const key = el.getAttribute('data-i18n-src');
            const val = this.t(key);
            if (val) el.setAttribute('src', val);
        });

        const pageTitleEl = document.querySelector('title[data-i18n]');
        if (pageTitleEl) {
            pageTitleEl.textContent = this.t(pageTitleEl.getAttribute('data-i18n'));
        }

        const flags = { ko: '🇰🇷', en: '🇺🇸', ja: '🇯🇵' };
        document.querySelectorAll('.lang-flag-badge').forEach(badge => {
            badge.textContent = flags[this.currentLang] || '🇰🇷';
        });

        // Localized phone screenshots
        document.querySelectorAll('.phone-slide').forEach(img => {
            const slideId = img.getAttribute('data-slide-id');
            if (slideId) {
                img.src = `assets/screenshots/${this.currentLang}/screen_${slideId}.png`;
            }
        });

        // Pass active language to privacy.html link
        document.querySelectorAll('a[href*="privacy.html"]').forEach(a => {
            a.href = `privacy.html?lang=${this.currentLang}`;
        });
    }

    init() {
        document.documentElement.lang = this.currentLang;
        this.applyToDOM();

        document.querySelectorAll('.rps-lang-select').forEach(select => {
            select.value = this.currentLang;
            select.addEventListener('change', (e) => {
                this.setLanguage(e.target.value);
            });
        });
    }
}

/**
 * Phone Screen Carousel / Slider
 * Smooth slide transition through the 5 actual in-game screenshots
 */
function initPhoneSlider() {
    const slides = document.querySelectorAll('.phone-slide');
    const dots = document.querySelectorAll('#sliderDots .dot');
    if (!slides.length) return;

    let currentIndex = 0;
    let timer = null;

    function showSlide(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        
        slides.forEach((slide, i) => {
            if (i === index) {
                slide.classList.add('active');
            } else {
                slide.classList.remove('active');
            }
        });

        dots.forEach((dot, i) => {
            dot.classList.toggle('active', i === index);
        });

        currentIndex = index;
    }

    function nextSlide() {
        showSlide(currentIndex + 1);
    }

    function resetTimer() {
        if (timer) clearInterval(timer);
        timer = setInterval(nextSlide, 3200);
    }

    dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => {
            showSlide(idx);
            resetTimer();
        });
    });

    // Simple touch swipe support
    const sliderEl = document.getElementById('phoneSlider');
    if (sliderEl) {
        let touchStartX = 0;
        sliderEl.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        sliderEl.addEventListener('touchend', (e) => {
            const touchEndX = e.changedTouches[0].screenX;
            const diff = touchEndX - touchStartX;
            if (Math.abs(diff) > 40) {
                if (diff < 0) {
                    showSlide(currentIndex + 1);
                } else {
                    showSlide(currentIndex - 1);
                }
                resetTimer();
            }
        }, { passive: true });
    }

    resetTimer();
}

window.rpsI18n = new RpsI18n();

document.addEventListener('DOMContentLoaded', () => {
    window.rpsI18n.init();
    initPhoneSlider();
});
